














import ListItem from '@/components/ListItem.vue'
import { camelCaseTitle } from '@/utilities/v-track-directive'
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
  components: {
    ListItem
  }
})
export default class TemplateListItem extends Vue {
  @Prop({ required: true }) readonly title!: string
  @Prop({ default: null }) readonly id!: number | null
  @Prop({ required: true }) readonly description!: string
  @Prop({ default: false }) readonly selected!: boolean

  get testingId () {
    // deprecate
    return `${this.title.replace(/ /g, '-').toLowerCase()}-button`
  }

  get testingName () {
    return `addTest-pickTemplate-${camelCaseTitle(this.title)}`
  }
}
